import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { InvoiceEmail } from '@/interfaces/components/clients/InvoiceEmail';
import { I } from '@fullcalendar/core/internal-common';

export default class ClientEmailAPI {
    public static async getAll(id: string) {
        let ClientEmails;

        try {
            ClientEmails = (await ApiController.get(ApiRoutes.clientEmail.getAll(id))) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(ClientEmails);
    }

    public static async update(ClientEmailInfo: InvoiceEmail, clientId: string) {
        let ClientEmail;

        const request = {
            data: {
                type: 'client_emails',
                id: ClientEmailInfo.id,
                attributes: {
                    email: ClientEmailInfo.email,
                    emailType: ClientEmailInfo.emailType,
                },
                relationships: {
                    client: {
                        data: {
                            type: 'clients',
                            id: clientId,
                        },
                    },
                },
            },
        };

        try {
            ClientEmail = (await ApiController.patch(
                ApiRoutes.clientEmail.update(ClientEmailInfo.id!),
                request
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(ClientEmail);
    }

    public static async create(ClientEmailInfo: InvoiceEmail, clientId: string) {
        let ClientEmail;
        const request = {
            data: {
                type: 'client_emails',
                attributes: {
                    email: ClientEmailInfo.email,
                    emailType: ClientEmailInfo.emailType,
                },
                relationships: {
                    client: {
                        data: {
                            type: 'clients',
                            id: clientId,
                        },
                    },
                },
            },
        };

        try {
            ClientEmail = (await ApiController.post(ApiRoutes.clientEmail.create, request)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(ClientEmail);
    }

    public static async delete(ClientEmailId: string) {
        try {
            await ApiController.delete(ApiRoutes.clientEmail.delete(ClientEmailId));
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve();
    }
}
